import { FacetValue } from 'lib/searchspring/client';
import { ReactElement, useEffect, useState } from 'react';

export default function Checkbox({
  filter,
  field,
  onChange,
  isColor,
}: {
  filter: FacetValue;
  field: string;
  onChange?: (filter: FacetValue) => void;
  isColor: boolean;
}): ReactElement {
  const [isChecked, setIsChecked] = useState(filter.active);
  const color = filter.label;
  const src = color === '#N/A' ? 'Black' : color?.replace(' ', '');
  const classes = `rounded-full inline-block p-1 mr-1 border-tertiary ${isChecked ? 'border' : ''}`;

  const handleChange = (value: boolean): void => {
    setIsChecked(value);
    if (onChange) {
      onChange(filter);
    }
  };

  useEffect(() => {
    setIsChecked(filter.active);
  }, [filter.active]);

  const Image = (): ReactElement => (
    <img
      src={`/images/colors/${src}.svg`}
      alt={`${color}`}
      className={classes}
      style={{ height: 28, width: 28 }}
    />
  );

  const Check = (): ReactElement => (
    <svg
      className="fill-current bg-white w-5 h-5 text-tertiary-actual pointer-events-none border-2 rounded mr-2 border-gray-400"
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(-5, -5)"
        fill="current"
        fillRule="nonzero"
        className={`${isChecked ? '' : 'hidden'}`}
      >
        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
      </g>
    </svg>
  );

  return (
    <label
      htmlFor={filter.label + '-' + field}
      className="text-left flex items-center my-1 whitespace-no-wrap w-full text-sm md:text-base"
    >
      <input
        id={filter.label + '-' + field}
        type="checkbox"
        className="opacity-0 absolute h-0 w-0 hidden"
        onChange={(e) => handleChange(e.target.checked)}
        aria-checked={isChecked}
      />
      {isColor ? <Image /> : <Check />}

      {filter.label}
    </label>
  );
}
